import { useRouter } from 'next/router'
import { usePathname, useSearchParams } from 'next/navigation'
import {
  useCheckoutAnalyticsChannel,
  useViewOrderAnalyticsChannel,
} from '~/hooks/useOrderAnalyticsChannel'

const CHECKOUT_ROUTES = [
  '/orders/payment-options',
  '/orders/traveller-details',
  '/orders/additional-details',
  '/orders/payment',
  '/orders/booking-status',
]

const SEARCH_TYPE_MAP = {
  EXPERIENCE: 'experiences',
  CAR_HIRE: 'car_hire',
  HOTEL: 'hotels',
}

export const useChannel = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  const isCheckoutPage = CHECKOUT_ROUTES.includes(router.pathname)
  const checkoutChannel = useCheckoutAnalyticsChannel({ isEnabled: isCheckoutPage })

  const isViewOrderPage = pathname?.includes('view-booking')
  const orderId = isViewOrderPage ? searchParams?.get('bookingId')?.toString() : undefined
  const viewOrderChannel = useViewOrderAnalyticsChannel({ orderId })

  if (isViewOrderPage) {
    return viewOrderChannel
  }

  if (isCheckoutPage) {
    return checkoutChannel
  }

  const isFlights = router.pathname.startsWith('/flights')

  if (isFlights) {
    return 'flights'
  }

  const isOrderHistory = router.pathname.startsWith('/order-history')
  if (isOrderHistory) {
    return ''
  }

  if (router.query.tab === 'carhire') {
    return 'car_hire'
  }

  if (router.query.searchType) {
    return SEARCH_TYPE_MAP[router.query.searchType as keyof typeof SEARCH_TYPE_MAP]
  }

  return ((router.query.searchType ?? router.query.tab) as string) ?? undefined
}
